import { render, staticRenderFns } from "./PausedLeadsListItemPlaceholder.vue?vue&type=template&id=51849b1c&scoped=true"
import script from "./PausedLeadsListItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./PausedLeadsListItemPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./PausedLeadsListItemPlaceholder.vue?vue&type=style&index=0&id=51849b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51849b1c",
  null
  
)

export default component.exports